import { useAppSelector } from "../../util/hooks";
import CadastrarPage from "./pages/cadastrar";
import GeralPage from "./pages/geral";

const pages: any = {
  geral: GeralPage,
  cadastrar: CadastrarPage,
};

const ConfiguracoesPontoPageController = () => {
  //estados globais
  const configuracaoResultadoSorteioState = useAppSelector((state) => state.configuracaoResultadoSorteio);

  const Page = pages[configuracaoResultadoSorteioState.page];

  return <Page key={configuracaoResultadoSorteioState.page} />;
};

export default ConfiguracoesPontoPageController;
